import { useEffect } from 'react';
import { captureException } from 'shared/sentry';
import { showForegroundPushToast } from './fcm/PushForegroundToast';
import { PUSH_SENTRY_TAGS } from './fcm/pushConstants';
import { subscribeForegroundPush } from './fcm/pushEvents';
import { isLoginWithSupportPassword } from '../utils/function';

export const useForegroundPushToasts = ({ enabled = true } = {}) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const onForegroundPushMessage = (event) => {
      if (isLoginWithSupportPassword()) {
        return;
      }

      try {
        showForegroundPushToast(event?.detail || {});
      } catch (error) {
        captureException(error, {
          tags: PUSH_SENTRY_TAGS,
          extra: { step: 'foreground-toast' },
        });
      }
    };

    return subscribeForegroundPush(onForegroundPushMessage);
  }, [enabled]);
};
